import { TypographyCaption, TypographyP2 } from '@heidi/design-system/typography';
import { useIntl } from 'react-intl';

import { Tint, TintedSegments } from './routine-instructions-changes';
import { diffWords } from './routine-word-diff';

export const ApprovalChangeField = ({
  label,
  before,
  after,
  showBefore = true,
}: {
  label: string;
  before: string;
  after: string;
  /** Create has no previous value, so the comparison column stays off. */
  showBefore?: boolean;
}) => {
  const intl = useIntl();
  if (!showBefore) {
    return (
      <div data-change="" className="flex flex-col gap-1">
        <TypographyP2 className="text-text-primary">{label}</TypographyP2>
        <TypographyP2 className="whitespace-pre-line text-text-primary">
          <Tint>{after}</Tint>
        </TypographyP2>
      </div>
    );
  }
  return (
    <div data-change="" className="flex flex-col gap-2">
      <TypographyP2 className="text-text-primary">{label}</TypographyP2>
      <div className="grid grid-cols-2 gap-x-4 gap-y-1">
        <TypographyCaption className="font-medium text-text-tertiary">
          {intl.formatMessage({
            defaultMessage: 'Before',
            id: 'iWhhLy+4w+',
            description: 'Column header for the current routine field value',
          })}
        </TypographyCaption>
        <TypographyCaption className="font-medium text-text-tertiary">
          {intl.formatMessage({
            defaultMessage: 'After',
            id: 'et/RGTCPdn',
            description: 'Column header for the proposed routine field value',
          })}
        </TypographyCaption>
        <TypographyP2 className="whitespace-pre-line text-text-secondary">
          {before}
        </TypographyP2>
        <TypographyP2 className="whitespace-pre-line text-text-primary">
          <TintedSegments segments={diffWords(before, after)} />
        </TypographyP2>
      </div>
    </div>
  );
};
